// Toggle States
export const OPEN_STATE = 'open';
export const CLOSED_STATE = 'closed';

// Api Request Responses
export const REQUEST_SUCCESS = 'Success';
export const REQUEST_FAILED = 'Failed';

// Unit Sim Constants
export const ACTIVE = 'active';
export const INACTIVE = 'inactive';
export const CANCELLED = 'cancelled';

// Address Constants
export const ASSOCIATED = 'associated';
export const ASSOCIATE = 'associate';
export const NEW = 'new';

// Tools Constants
export const IMPORT = 'import';
export const EXPORT = 'export';
export const REPORTING = 'reporting';
export const DIAGNOSTIC = 'diagnostic';
export const NON_ALLOCATED_SIM_IMPORT = 'nonallocatedsimimport';

// Traffic Constants
export const HISTORY = 'history';
export const LIVE = 'live';

// Shared Entity Constants
export const COMPANY = 'company';
export const CONTACT = 'contact';
export const ACTION = 'action';
export const PRODUCT = 'product';
export const SIMAPN = 'simapn';
export const SIMTYPE = 'simtype';
export const UNITPLAN = 'unitplan';
export const UNITFIRMWARE = 'unitfirmware';

// Company Type Constants
export const MONCENTRE_COMPANY = 'monitoring centre';
export const BUREAU_COMPANY = 'bureau';
export const ALL_COMPANY = 'all';

// Product Type Constants
export const TRANSMITTER_TYPE = 'transmitter';
export const ACTION_REQUIRED = true;

// program and control unit constants
export const UNIT_TYPE_FALCON = 'txc+ falcon';
export const UNIT_TYPE_TXCPLUS = 'txc+j';
export const UNIT_FALCON_INPUT_COUNT = 14;
export const UNIT_FALCON_PRODUCT_ID = 'PD00000015';
export const UNIT_TXC_PLUS_PRODUCT_ID = 'PD00000001';

export const CONTROL_TYPE_ALARM = 1;
export const CONTROL_TYPE_CUSTOM = 2;

export const TRK_DEFAULT_PULSE_ON_TIME = 2000;

// program control request types
export const PROGRAM_REQUEST = 'write';
export const READ_REQUEST = 'read';
export const CONTROL_REQUEST = 'control';
export const JOB_RETRY = 'retry';
export const JOB_CANCEL = 'cancel';

// days of week names
export const DAY_SUNDAY_NAME = 'sunday';
export const DAY_MONDAY_NAME = 'monday';
export const DAY_TUESDAY_NAME = 'tuesday';
export const DAY_WEDNESDAY_NAME = 'wednesday';
export const DAY_THURSDAY_NAME = 'thursday';
export const DAY_FRIDAY_NAME = 'friday';
export const DAY_SATURDAY_NAME = 'saturday';

// am pm constants
export const TIME_AM = 'am';
export const TIME_PM = 'pm';

// days of week values
export const DAY_SUNDAY_VALUE = '0';
export const DAY_MONDAY_VALUE = '1';
export const DAY_TUESDAY_VALUE = '2';
export const DAY_WEDNESDAY_VALUE = '3';
export const DAY_THURSDAY_VALUE = '4';
export const DAY_FRIDAY_VALUE = '5';
export const DAY_SATURDAY_VALUE = '6';





// WEBPACK FOOTER //
// ./angularApp/app/shared/constants.ts